export interface Pedido {
  id: string;
  fecha: string;
  cliente_nombre: string;
}

export interface PedidoDetalle {
  codigo_sistema: string;
  nombre: string;
  cantidad: string;
  unidad_medida: string;
  precio: string;
  detalle: string;
}

export interface UnidadMedida {
  id: string;
  descripcion: string;
  precio: number;
  contenido: number;
  unidad_contenido: string;

}

export interface Articulo {
  id: string;
  marca: string;
  nombre: string;
  imagen: string;
  unidades_medida: UnidadMedida[];
  caracteristicas: string;
  hay_stock: string;
}

export interface Catalogo {
  id: string;
  codigo_sistema: string;
  nombre: string;
}

export interface Marca {
  id: string;
  codigo_sistema: string;
  nombre: string;
  catalogos: string[];
}

export interface Cliente {
  correo: string;
  nombre: string;
  documento_identidad: string;
  telefono: string;
  direccion: string;
}

export interface Carrito {
  id: string;
  cliente: Cliente;
  items: CarritoItem[];
}

export interface CarritoItem{
  id: string;
  articulo: Articulo;
  cantidad: number;
  unidad_medida: UnidadMedida;
  detalle: string;
  sub_total: number;
}

class ArticuloImpl implements Articulo {
  id: string;
  marca: string;
  nombre: string;
  imagen: string;
  unidades_medida: UnidadMedida[];
  caracteristicas: string
  hay_stock: string
  constructor () {
    this.id = ''
    this.marca = ''
    this.nombre = ''
    this.imagen = ''
    this.unidades_medida = []
    this.caracteristicas = ''
    this.hay_stock = 'S'
  }
}

class UnidadMedidaImpl implements UnidadMedida {
  id: string;
  descripcion: string;
  precio: number;
  contenido: number
  unidad_contenido: string
  constructor () {
    this.id = ''
    this.descripcion = ''
    this.precio = 0
    this.contenido = 1
    this.unidad_contenido = ''
  }
}

class ClienteImpl implements Cliente {
  correo: string;
  nombre: string;
  documento_identidad: string;
  telefono: string;
  direccion: string;

  constructor (id = '') {
    this.nombre = id
    this.correo = ''
    this.documento_identidad = ''
    this.telefono = ''
    this.direccion = ''
  }
}

class CarritoImpl implements Carrito {
  id: string;
  cliente: Cliente;
  items: CarritoItem[];
  constructor (id = '') {
    this.id = id
    this.cliente = new ClienteImpl()
    this.items = []
  }
}

class CarritoItemImpl implements CarritoItem {
  id: string;
  articulo: Articulo;
  cantidad: number;
  unidad_medida: UnidadMedida;
  detalle: string;
  sub_total: number;

  constructor (id = '') {
    this.id = id
    this.articulo = new ArticuloImpl()
    this.cantidad = 0
    this.unidad_medida = new UnidadMedidaImpl()
    this.detalle = ''
    this.sub_total = 0
  }
}

export function getEmptyUnidadMedida () {
  return new UnidadMedidaImpl()
}
export function getEmptyArticulo () {
  return new ArticuloImpl()
}

export function getEmptyCliente (id = '') {
  return new ClienteImpl(id)
}

export function getEmptyCarrito (id = '') {
  return new CarritoImpl(id)
}

export function getEmptyCarritoItem (id = '') {
  return new CarritoItemImpl(id)
}
